var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 32.191C105 28.2195 101.78 25 97.809 25H32.191C28.2195 25 25 28.2195 25 32.191V97.809C25 101.78 28.2195 105 32.191 105H97.809C101.78 105 105 101.78 105 97.809V32.191Z",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 43C108 39.6863 105.314 37 102 37H93V94H102C105.314 94 108 91.3137 108 88V43Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 68,
    rx: 6,
    transform: "matrix(-1 0 0 1 93 31)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 79,
    rx: 6,
    transform: "matrix(-1 0 0 1 78 26)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutro);
export default __webpack_public_path__ + "static/media/outro.5dfbcc480ad84997e947a4aa8fb4bd81.svg";
export { ForwardRef as ReactComponent };